export default __webpack_public_path__ + "static/media/2Y.7a49720f.png";